var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "url(#paint0_linear_1134_2501)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.62473 15V7.36364H11.3691V15H8.62473ZM9.99689 6.56818C9.62568 6.56818 9.3075 6.44555 9.04235 6.20028C8.7772 5.95502 8.64462 5.66004 8.64462 5.31534C8.64462 4.97064 8.7772 4.67566 9.04235 4.4304C9.3075 4.18513 9.62568 4.0625 9.99689 4.0625C10.3714 4.0625 10.6896 4.18513 10.9514 4.4304C11.2166 4.67566 11.3492 4.97064 11.3492 5.31534C11.3492 5.66004 11.2166 5.95502 10.9514 6.20028C10.6896 6.44555 10.3714 6.56818 9.99689 6.56818Z",
    fill: "#1B1B1B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1134_2501",
    x1: -1.58416,
    y1: -4.36623,
    x2: 20.7265,
    y2: -3.98322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconRed);
export default __webpack_public_path__ + "static/media/info-icon-red.2a63cd0bc801f2f1d1829f823e373cc6.svg";
export { ForwardRef as ReactComponent };